var map = {
	"./__mocks__/languageMock": 93,
	"./__mocks__/languageMock.js": 93,
	"./languages.demo.digvurd.gb-en": 68,
	"./languages.demo.digvurd.gb-en.json": 68,
	"./languages.demo.digvurd.nb-no": 69,
	"./languages.demo.digvurd.nb-no.json": 69,
	"./languages.gb-en": 70,
	"./languages.gb-en.json": 70,
	"./languages.hiof.gb-en": 71,
	"./languages.hiof.gb-en.json": 71,
	"./languages.hiof.nb-no": 72,
	"./languages.hiof.nb-no.json": 72,
	"./languages.nb-no": 73,
	"./languages.nb-no.json": 73,
	"./languages.uit.gb-en": 74,
	"./languages.uit.gb-en.json": 74,
	"./languages.uit.nb-no": 75,
	"./languages.uit.nb-no.json": 75,
	"./languages.usn.gb-en": 76,
	"./languages.usn.gb-en.json": 76,
	"./languages.usn.nb-no": 77,
	"./languages.usn.nb-no.json": 77,
	"./languages.usn.vernepleie.gb-en": 78,
	"./languages.usn.vernepleie.gb-en.json": 78,
	"./languages.usn.vernepleie.nb-no": 79,
	"./languages.usn.vernepleie.nb-no.json": 79,
	"./languages.vid.gb-en": 80,
	"./languages.vid.gb-en.json": 80,
	"./languages.vid.nb-no": 81,
	"./languages.vid.nb-no.json": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;